import React from 'react';

function CompanyDisambiguationModal({
  show,
  onClose,
  query,
  matches,
  onSelect,
  loading
}) {
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto'
      }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', color: '#1d2934', marginBottom: '8px' }}>
          Multiple Companies Found
        </h2>
        <p style={{ color: '#5e778a', fontSize: '14px', marginBottom: '20px' }}>
          Your search for "<strong>{query}</strong>" matches {matches?.length || 0} companies. 
          Please select the one you want to analyze:
        </p>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#5e778a' }}>
            Loading matches...
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
            {matches?.map((match, idx) => (
              <button
                key={idx}
                onClick={() => onSelect(match.assignee)}
                style={{
                  textAlign: 'left',
                  padding: '14px 16px',
                  background: '#f8f9fa',
                  border: '2px solid #e0e0e0',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = '#53dafc';
                  e.currentTarget.style.background = '#f0f9ff';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  e.currentTarget.style.background = '#f8f9fa';
                }}
              >
                <div style={{ fontWeight: '600', color: '#1d2934', marginBottom: '4px' }}>
                  {match.assignee}
                </div>
                <div style={{ fontSize: '13px', color: '#5e778a' }}>
                  {match.granted_count?.toLocaleString() || 0} granted | {match.pending_count?.toLocaleString() || 0} pending
                </div>
              </button>
            ))}
          </div>
        )}

        <div style={{ 
          backgroundColor: '#fef3c7', 
          padding: '12px 16px', 
          borderRadius: '8px', 
          marginBottom: '20px' 
        }}>
          <p style={{ fontSize: '13px', color: '#92400e', margin: 0 }}>
            💡 <strong>Why am I seeing this?</strong> Company names can appear in different forms 
            in patent records. Selecting the exact name ensures accurate analysis.
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              border: '1px solid #e0e0e0',
              borderRadius: '4px',
              background: 'white',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompanyDisambiguationModal;